function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__title title-def title-def_sec3">Метилгидросиликоновая жидкость  RUTESIL® TU 157</div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/7.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <h4>Описание</h4>
              <p>Жидкость Rutesil® TU 157 – это низковязкое бесцветное полидиметилгидридсилоксановое  масло. Хорошо растворяется в ароматических и хлорированных углеводородах. Не растворяется в низших спиртах и воде. <br/> Применяется для улучшения влагостойкости асбоцементных и гипсокартонных плит, керамических материалов; для приготовления антиадгезионных смазок для стеклоформующих поверхностей; для придания гидрофобных (водоотталкивающих) свойств различным тканям, бумаге, коже.</p>
              <p>Покрытие после обработки жидкостью Rutesil® TU 157:</p>
              <ul>
                <li>не препятствует нормальному воздухообмену конструкции, не меняет внешнего вида материала, способствует уменьшению загрязняемости фактурного слоя и увеличивает срок его службы;</li>
                <li>препятствует снижению теплоизоляционных свойств материала, обладает хорошей стойкостью во времени к действию различных факторов, в том числе попеременного замораживания и оттаивания, а также устойчиво к действию ультрафиолетовых и инфракрасных лучей, попеременного увлажнения и высыхания;</li>
                <li>придает гидрофобные свойства, улучшение сыпучести и предотвращение слеживаемости порошковых и гранулированных материалов.</li>
              </ul>
              <p></p>
              <h4>Основные характеристики</h4>
              <p>Содержание основного вещества:  100%<br/>Содержанием летучих компонентов:  не более  3%<br/>Содержание водорода:  приблизительно  1,6%<br/>рН:  5-7</p>
              <p></p>
              <h4>Упаковка</h4>
              <p>Контейнеры IBC 1 м куб.</p>
              <p></p>
              <h4>Гарантийный срок хранения</h4>
              <p>1 год со дня изготовления.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;